import { Calendar } from 'lucide-react';
import * as React from 'react';
import { Translate } from 'react-localize-redux';
import CalendarView from '../../containers_v2/calendar/CalendarView';
import { PrimaryColor } from '../../styles/global/css/Utils';
import { Route } from '../Routes';

const CalendarRoutes = (): Route[] => [
	{
		component: CalendarView,
		path: '/calendar',
		name: <Translate id="general.calendar" />,
		role: ['all'],
		key: 'calendar',
		sectionKey: 'calendar',
		title: 'calendar',
		subTitle: 'calendar',
		restricted: false,
		exact: true,
		logoImg: <Calendar size='16' />,
		hoverImg: <Calendar color={PrimaryColor} size='16' />,
		activeImg: <Calendar color={PrimaryColor} size='16' />,
		permission: ['ViewCalendar'],
		menu: false,
		submenu: true,
		precedence: 0
	}
];

export default CalendarRoutes;
